export const FINGER_PRINT_PUBLIC_KEY_META = {
  /** OS-下载中心-下载 */
  DOWNLOAD_CENTER:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCTn5mAl9ZCxsTQgkD2DocqRQ7NFEm4BkKizz4tubsiMVH3yxDJhUPFkUaKaTWqTa6yBlhmdWP+5q9CqabgbxIHAeYlGtTw/joR7ZHIsJMTOhUK85nGg8kNy4I4O1g9+OYrTJI7r17xSuUH9EbSQH7GqHr3X6pYUY7aFWhNpwFhDwIDAQAB',
}

export const CAPTCHA_SCENE = {
  /**OW-下载中心-下载 */
  DOWNLOAD_CENTER: 'LgOwDcD',
}

export const CAPTCHA_TYPE_META = {
  /**OW-下载中心-下载 */
  downloadCenter: 'DOWNLOAD_CENTER',
}
